import React, { useState } from "react";
import "./muiCheckbox.scss";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const nullableFormNames = ["Insert Material", "Socket Option"];
const noneOptionIds = {
  "Insert Material": 31,
  "Socket Option": 163
};
const canHaveOnlyOne = {
  "Insert Material": 108,
};

const MuiCheckbox = ({
  checkboxes,
  boxLabel,
  onChange,
  value,
  defaultValue,
  defaultChecked,
}) => {
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (label) => {
    const noneOptionId = noneOptionIds[boxLabel];
    const canHaveOnlyOneId = canHaveOnlyOne[boxLabel];
    const labelId = parseInt(label);
    
    let currentValues = checkedItems;
    if (Object.keys(currentValues).length === 0) {
      if (defaultValue) {
        currentValues = Object.fromEntries(
          Object.entries(defaultValue).filter(([id, value]) => value)
        );
        currentValues[labelId] = !currentValues[labelId];
      }
    }

    if (nullableFormNames.includes(boxLabel)) {
      let newValues = currentValues;
      if (boxLabel !== "Insert Material") {
        if (labelId === noneOptionId && !currentValues[noneOptionId]) {
          checkboxes.forEach(checkout => {
            newValues[checkout.id] = false
          })
          newValues[labelId] = true;
        } else if (labelId === noneOptionId && currentValues[noneOptionId]) {
          newValues[noneOptionId] = false;
        } else {
          newValues[noneOptionId] = false;
          newValues[labelId] = !currentValues[labelId];
        }
      } else {
        if (currentValues[canHaveOnlyOneId] && labelId !== noneOptionId) {
          if (labelId === canHaveOnlyOneId) {
            newValues[labelId] = false;
          } else if (labelId !== canHaveOnlyOneId) {
            checkboxes.forEach(checkout => {
              if (checkout.id !== labelId) {
                newValues[checkout.id] = false;
              }
            });
            newValues[labelId] = !currentValues[labelId];
            newValues[canHaveOnlyOneId] = true;
          }
        }
        else if (labelId === noneOptionId && currentValues[noneOptionId]) {
          newValues[noneOptionId] = false;
        }
        else if (!currentValues[canHaveOnlyOneId] && labelId === canHaveOnlyOneId) {
          if (labelId === canHaveOnlyOneId) {
            newValues[labelId] = true;
            newValues[noneOptionId] = false;
          }
        } else {
          checkboxes.forEach(checkout => {
            if (checkout.id !== labelId) {
              newValues[checkout.id] = false;
            }
          });
          newValues[noneOptionId] = false;
          newValues[labelId] = !currentValues[labelId];
        }
      }

      defaultValue = newValues
      setCheckedItems((prevState) => ({
        ...prevState,
        ...defaultValue,
      }));
    } else {
      setCheckedItems((prevState) => ({
        ...prevState,
        [labelId]: !prevState[labelId],
      }));
    }
  };

  if (nullableFormNames.includes(boxLabel)) {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label"><div className="font-weight-bolder">{boxLabel}</div></FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id, e);
                  }}
                  checked={
                    checkedItems[checkbox.id] ??
                    defaultValue?.[checkbox.id] ??
                    defaultChecked ??
                    false
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  } else {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label"><div className="font-weight-bolder">{boxLabel}</div></FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id);
                  }}
                  defaultChecked={
                    defaultValue
                      ? defaultValue?.[checkbox?.id]
                      : defaultChecked
                        ? defaultChecked
                        : null
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  }
};

export default MuiCheckbox;
